import InstrumentPrecisionTableCell from './InstrumentPrecisionTableCell';

export default InstrumentPrecisionTableCell;
